import { Box, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import React, { FC } from 'react';

import TitleLogo from '~/shared/components/TitleLogo';

const useStyles = makeStyles(theme => ({
  paperContent: {
    width: 375 - theme.spacing(4) * 2,
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

type Props = {
  title?: string;
};

const AuthPaper: FC<Props> = ({ children, title }) => {
  const classes = useStyles();

  return (
    <Paper>
      <div className={classes.paperContent}>
        <TitleLogo mb={2} />

        {title && (
          <Box mb={1}>
            <Typography component="h1" variant="h5">
              {title}
            </Typography>
          </Box>
        )}

        {children}
      </div>
    </Paper>
  );
};

export default AuthPaper;
